import { render, staticRenderFns } from "./TextScroll.vue?vue&type=template&id=20fff4e3&scoped=true"
import script from "./TextScroll.vue?vue&type=script&lang=js"
export * from "./TextScroll.vue?vue&type=script&lang=js"
import style0 from "./TextScroll.vue?vue&type=style&index=0&id=20fff4e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fff4e3",
  null
  
)

export default component.exports